import { apiRequest, getCurrentUser } from './apiClient';
import { availableListings } from './listingService';
async function mine(type) {
  const user = await getCurrentUser();
  return availableListings(await apiRequest(type + '/getMyAds/' + encodeURIComponent(user.uid)));
}
export const getMyAdsService = () => mine('Biens');
export const getMyAdsVacationService = () => mine('Vacation');
